import { useCallback } from 'react';

import type { AssetsSegmentElasticSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/assets';
import { useFullscreen } from '@iconik-io/shared-lib/src/react/hooks/use_fullscreen';
import { useBasePlayerContext } from '@iconik-io/unified-player-ui-react';

import {
  type SetActivePersonSegmentOptions,
  setActivePersonSegment,
} from '../../../../ducks/panels/asset_face_recognition/thunks';
import { useAppDispatch } from '../../../../store/react_redux_typed';

/** Return callback to jump to person *segment*, and optionally start playback */
export function useOnPersonSegmentClick() {
  const { store } = useBasePlayerContext();
  const dispatch = useAppDispatch();
  const isFullscreen = useFullscreen();
  const handleSegmentClick = useCallback(
    (
      segment: AssetsSegmentElasticSchemaWithIdNullable,
      options?: SetActivePersonSegmentOptions,
    ) => {
      if (!store) {
        return;
      }

      dispatch(
        setActivePersonSegment(store, segment.id, isFullscreen, options),
      );
    },
    [isFullscreen],
  );

  return handleSegmentClick;
}
